import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import moment from 'moment';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { BASE_URL } from '../constants';

const CourseDetails = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enrollMessage, setEnrollMessage] = useState(null);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await fetch(`${BASE_URL}/course/${id}`);
        const data = await response.json();
        setCourse(data);
      } catch (error) {
        console.error('Error fetching course details:', error);
      }
    };
    fetchCourseDetails();
  }, [id]);
  const handleEnroll = async () => {
    setLoading(true);
    setEnrollMessage(null); // Reset message on each click

    try {
      const response = await fetch(`${BASE_URL}/course/enroll`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ courseId: id })
      });

      const data = await response.json();

      if (response.ok) {
        setEnrollMessage({ type: 'success', text: 'Enrolled successfully!' });
      } else {
        setEnrollMessage({ type: 'error', text: data.message || 'Enrollment failed.' });
      }
    } catch (error) {
      console.error('Error enrolling in course:', error);
      setEnrollMessage({ type: 'error', text: 'An error occurred. Please try again.' });
    } finally {
      setLoading(false);
    }
  };
  if (!course) {
    return (
      <Container className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p>Loading course details...</p>
      </Container>
    );
  }

  return (
    <Layout>
     <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6}>
          <Card className="shadow-lg border-0">
            <Card.Img
              variant="top"
              src={course.photo || 'https://via.placeholder.com/800x400'}
              alt={course.name}
              className="img-fluid"
            />
            <Card.Body>
              <h2 className="text-primary mb-3">{course.name}</h2>
              <Card.Text className="mt-4">{course.description}</Card.Text>
              <Card.Text className="text-muted">
                <strong>Instructor:</strong> {course.instructor || 'N/A'}
              </Card.Text>
              <Card.Text className="text-muted">
                <strong>Start Date:</strong> {moment(course.startDate).format('MMMM Do, YYYY')}
              </Card.Text>
              <Card.Text className="text-muted">
                <strong>End Date:</strong> {moment(course.endDate).format('MMMM Do, YYYY')}
              </Card.Text>

              {enrollMessage && (
                <Alert variant={enrollMessage.type === 'success' ? 'success' : 'danger'}>
                  {enrollMessage.text}
                </Alert>
              )}

              <Button
                variant="primary"
                className="mt-3"
                onClick={handleEnroll}
                disabled={loading}
                block
              >
                {loading ? 'Enrolling...' : 'Enroll Now'}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </Layout>
  );
};

export default CourseDetails;
